const PolicySection = ({ title, children }) => (
  <>
    <h2 className="text-2xl font-bold text-[#0B2A57] mb-4 mt-8" style={{ fontFamily: 'Cabinet Grotesk' }}>
      {title}
    </h2>
    {children}
  </>
);

export default PolicySection;
